import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import axios from "../../axios-vmou";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import styles from "./prcentre.module.css";
import Navbar from "../main/navbar";
import logo from "../../assets/vmou.png";
import { Sidebar } from 'primereact/sidebar';
import * as actions from '../../store/actions/index'

const Prcentre = (props) => {
  const [visibleRight, setVisibleRight] = useState(false);
  const onSignout = () => {
    props.onlogout();
  }
  let emptyPrcentre = {
    userid:'',
    email: "",
    name: "",
    phone: "",
    bank: "",
    branch: "",
    ifsccode: "",
    accno: "",
    panno: "",
  };

  const [prcentre, setPrcentre] = useState(emptyPrcentre);
  const [prcentres, setPrcentres] = useState([]);
  const [prcities, setPrcities] = useState([]);
  const [selectedPrcentres, setSelectedPrcentres] = useState(null);
  const [prcentreDialog, setPrcentreDialog] = useState(false);
  const [deletePrcentreDialog, setDeletePrcentreDialog] = useState(false);

  const [mode, setMode] = useState("");

  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const toast = useRef(null);
  const dt = useRef(null);

  useEffect(() => {
    let authOptions = {
      method: "GET",
      url: "/prcentre/Coord/"+props.userid,
      data: { 'userid': props.userid },
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    };
    axios(authOptions)
      .then((response) => {
        setPrcentres(response.data);
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: error.response.data,
        });
        setPrcentres([]);
      });
    authOptions = {
      method: "put",
      url: "/prcity/Coord/"+props.userid,
      data: { 'userid': props.userid },
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    };
    axios(authOptions)
      .then((response) => {
        setPrcities(response.data);
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: error.response.data,
        });
        setPrcities([]);
      });
  }, [props.userid]); 

  const openNew = () => {
    setPrcentre(emptyPrcentre);
    setSubmitted(false);
    setMode("New");
    setPrcentreDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setPrcentreDialog(false);
  };

  const hideDeletePrcentreDialog = () => {
    setDeletePrcentreDialog(false);
  };

  const savePrcentre = () => {
    setSubmitted(true);

    if (prcentre.name.trim()) {
      let _prcentres = [...prcentres];
      let _prcentre = { ...prcentre };
      _prcentre.userid = props.userid;
      if (mode === "Edit") {
        const index = findIndexById(prcentre._id);
        _prcentres[index] = _prcentre;
        let authOptions = {
          method: "PUT",
          url: "/prcentre/",
          data: _prcentre,
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        };
        axios(authOptions)
          .then((response) => {
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Prcentre Edited",
              life: 3000,
            });
            setPrcentres(_prcentres);
            setPrcentreDialog(false);
            setPrcentre(emptyPrcentre);
          })
          .catch((error) => {
            toast.current.show({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data,
            });
          });
      } else {
        let authOptions = {
          method: "POST",
          url: "/prcentre/",
          data: _prcentre,
          headers: {
            "x-auth-token": localStorage.getItem("token"),
          },
        };
        axios(authOptions)
          .then((response) => {
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Prcentre Created",
              life: 3000,
            });
            // _prcentres.push(response.data);
            setPrcentres(_prcentres);
            setPrcentreDialog(false);
            setPrcentre(emptyPrcentre);
          })
          .catch((error) => {
            toast.current.show({
              severity: "error",
              summary: "Error Message",
              detail: error.response.data,
            });
          });
      }
    }
  };

  const editPrcentre = (prcentre) => {
    setPrcentre({ ...prcentre });
    setMode("Edit");
    setPrcentreDialog(true);
  };

  const confirmDeletePrcentre = (prcentre) => {
    setPrcentre(prcentre);
    setDeletePrcentreDialog(true);
  };

  const deletePrcentre = () => {
    let authOptions = {
      method: "put",
      url: "/prcentre/deactivate",
      data: prcentre,
      headers: {
        "x-auth-token": localStorage.getItem("token"),
      },
    };
    axios(authOptions)
      .then((response) => {
          let _prcentres = prcentres.filter(val => val.email !== prcentre.email);
          setPrcentres(_prcentres);
        setDeletePrcentreDialog(false);
        setPrcentre(emptyPrcentre);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Prcentre Deactivated",
          life: 3000,
        });
      })
      .catch((error) => {
        toast.current.show({
          severity: "error",
          summary: "Error Message",
          detail: error.response.data,
        });
      });
  };

  const findIndexById = (id) => {
    let index = -1;
    for (let i = 0; i < prcentres.length; i++) {
      if (prcentres[i]._id === id) {
        index = i;
        break;
      }
    }
    return index;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _prcentre = { ...prcentre };
    _prcentre[`${name}`] = val;
    setPrcentre(_prcentre);
  };
  // const onInputChangeboolean = (e, name) => {
  //     const val = e.value;
  //     let _prcentre = {...prcentre};
  //     _prcentre[`${name}`] = val;
  //     setPrcentre(_prcentre);
  // }

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="New"
          icon="pi pi-plus"
          className="p-button-success p-mr-2"
          onClick={openNew}
        />
      </React.Fragment>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
      </React.Fragment>
    );
  };

  // const isAdminBodyTemplate = (rowData) => {
  //     return (rowData.isAdmin?<span >True</span>:<span >False</span> );
  // }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-text p-button-success p-mr-2"
          onClick={() => editPrcentre(rowData)}
        />
        <Button
          icon="pi pi-trash"
          className="p-button-rounded p-button-text p-button-warning"
          onClick={() => confirmDeletePrcentre(rowData)}
        />
      </React.Fragment>
    );
  };

  const header = (
    <div className={styles.tableheader}>
      <h4 className="mx-0 my-1">Manage Prcentres</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span>
    </div>
  );
  const prcentreDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDialog}
      />
      <Button
        label="Save"
        icon="pi pi-check"
        className="p-button-text"
        onClick={savePrcentre}
      />
    </React.Fragment>
  );
  const deletePrcentreDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        className="p-button-text"
        onClick={hideDeletePrcentreDialog}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        className="p-button-text"
        onClick={deletePrcentre}
      />
    </React.Fragment>
  );


  return (
    <div className={styles.datatablecruddemo}>
      <Toast ref={toast} />
      <Sidebar className="flex align-items-center " visible={visibleRight} position="right" onHide={() => setVisibleRight(false)}>
          <h2>User Profile....</h2>
          <h5>User ID : {props.email}</h5>
          <h5>Name        : {props.username}</h5>
          <Button className="p-button-text p-button-danger ml-4" style={{}} onClick={onSignout}>Sign Out</Button>
        </Sidebar>
      <div className="Headerusr" style={{ position: "sticky" }}>
        <img
          src={logo}
          alt="VMOU"
          height={100}
          width={90}
          style={{ margin: "0px 0 0 20px" }}
        ></img>
        <h2 style={{ marginTop: "0", textAlign: "center" }}>
          RC Module
          <br />
          Practical Centre Management
        </h2>
        <div className="Userusr" onClick={(e) => setVisibleRight(true)}>
          <i style={{'fontSize': '1.5em'}} className="pi pi-user mr-6 mt-2 text-right"></i>
          <h4 style={{margin:'0 30px 0 0',textAlign:'end'}} >Hi, {props.username}</h4>
        </div>
      </div>
      <Navbar />
      <div className={styles.card}>
        <Toolbar
          className="p-mb-4"
          left={leftToolbarTemplate}
          right={rightToolbarTemplate}
        ></Toolbar>

        <DataTable
          resizableColumns
          columnResizeMode="fit"
          showGridlines
          className="p-datatable-sm"
          ref={dt}
          value={prcentres}
          selection={selectedPrcentres}
          onSelectionChange={(e) => setSelectedPrcentres(e.value)}
          dataKey="email"
          sortField="email"
          sortOrder={1}
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} prcentres"
          globalFilter={globalFilter}
          header={header}
          responsiveLayout="scroll"
        >
          <Column
            field="prcity.explace"
            header="City"
            style={{ width: "10%" , padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            field="email"
            header="Email ID"
            sortable
            style={{ width: "15%" , textAlign:"center",padding:'0 1px 0 4px' }}
          ></Column>
          <Column
            field="name"
            header="Name"
            sortable
            style={{ width: "20%"  , padding:'0 1px 0 1px'}}
          ></Column>
          <Column field="phone" header="Phone" style={{ width: "8%" , padding:'0 1px 0 1px' }}></Column>
          <Column
            field="contactperson"
            header="Contact Person"
            sortable
            style={{ width: "10%" , padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            field="address"
            header="Address"
            style={{ width: "25%" , padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            field="status"
            header="Status"
            sortable
            style={{ width: "6%" , padding:'0 1px 0 1px' }}
          ></Column>
          <Column
            body={actionBodyTemplate}
            exportable={false}
            style={{  padding:'0 1px 0 1px'}}
          ></Column>
        </DataTable>
      </div>

      <Dialog
        visible={prcentreDialog}
        style={{ width: "550px" }}
        header="Prcentre Details"
        modal
        className="p-fluid"
        footer={prcentreDialogFooter}
        onHide={hideDialog}
      >
        <div className="p-field">
          <label htmlFor="Prcity">Practical City*</label>
          <Dropdown className="my-1 h-auto" value={prcentre.prcity} options={prcities} optionLabel="explace" onChange={(e) => onInputChange(e, "prcity")}  placeholder="Select City" />
        </div>

        <div className="p-field">
          <label htmlFor="email">Email ID*</label>
          <InputText
            htmlFor="emailid"
            keyfilter="email"
            pattern="[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
            value={prcentre.email}
            onChange={(e) => onInputChange(e, "email")}
            required
            className={classNames({
              "p-invalid": submitted && !prcentre.email,
            })}
          />
          {submitted && !prcentre.email && (
            <small className="p-error">Email Id is required.</small>
          )}
        </div>
        <div className="p-field">
          <label htmlFor="name">Centre Name*</label>
          <InputText
            id="name"
            value={prcentre.name}
            onChange={(e) => onInputChange(e, "name")}
            required
            className={classNames({ "p-invalid": submitted && !prcentre.name })}
          />
          {submitted && !prcentre.name && (
            <small className="p-error">Name is required.</small>
          )}
        </div>
        <div className="p-field">
          <label htmlFor="phone">Contact No*</label>
          <InputText
            id="phone"
            value={prcentre.phone}
            onChange={(e) => onInputChange(e, "phone")}
            required
            className={classNames({
              "p-invalid": submitted && !prcentre.phone,
            })}
          />
          {submitted && !prcentre.phone && (
            <small className="p-error">Pnone is required.</small>
          )}
        </div>
        <div className="p-field">
          <label htmlFor="phone]">Contact Person Name*</label>
          <InputText
            id="contactperson"
            value={prcentre.contactperson}
            onChange={(e) => onInputChange(e, "contactperson")}
            required
            className={classNames({
              "p-invalid": submitted && !prcentre.contactperson,
            })}
          />
          {submitted && !prcentre.contactperson && (
            <small className="p-error">Contact Person is required.</small>
          )}
        </div>
        <div className="p-field">
          <label htmlFor="name">Address*</label>
          <InputTextarea
            id="address"

            value={prcentre.address}
            onChange={(e) => onInputChange(e, "address")}
            required
            className={classNames({
              "p-invalid": submitted && !prcentre.address,
            })}
          />
          {submitted && !prcentre.address && (
            <small className="p-error">Address is required.</small>
          )}
        </div>
      </Dialog>

      <Dialog
        visible={deletePrcentreDialog}
        style={{ width: "450px" }}
        header="Confirm"
        modal
        footer={deletePrcentreDialogFooter}
        onHide={hideDeletePrcentreDialog}
      >
        <div className={styles.confirmationcontent}>
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem" }}
          />
          {prcentre && (
            <span>
              Are you sure you want to Deactivate <b>{prcentre.name}</b>?
            </span>
          )}
        </div>
      </Dialog>

    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    username: state.auth.username,
    userid: state.auth.userid,
    email: state.auth.email,
    isAuth: state.auth.token !== null,
  };
};

const mapDispatchToProps = dispatch => {
  return {
      onlogout:() => dispatch(actions.logout())
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Prcentre);